export const SIGNIN = "SIGNIN";
export const AUTHENTICATED = "AUTHENTICATED";
export const SIGNOUT = "SIGNOUT";
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS";
export const SIGNUP = "SIGNUP";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SHOW_AUTH_MESSAGE = "SHOW_AUTH_MESSAGE";
export const SHOW_AUTH_SUCCESS_MESSAGE = "SHOW_AUTH_SUCCESS_MESSAGE";
export const HIDE_AUTH_MESSAGE = "HIDE_AUTH_MESSAGE";
export const SHOW_LOADING = "SHOW_LOADING";
export const EMAIL = "email";
export const AUTH_TOKEN = "auth_token";
export const SIGNIN_WITH_GOOGLE = "SIGNIN_WITH_GOOGLE";
export const SIGNIN_WITH_GOOGLE_AUTHENTICATED = "SIGNIN_WITH_GOOGLE_AUTHENTICATED";
export const SIGNIN_WITH_FACEBOOK = "SIGNIN_WITH_FACEBOOK";
export const SIGNIN_WITH_FACEBOOK_AUTHENTICATED = "SIGNIN_WITH_FACEBOOK_AUTHENTICATED";
export const REDIRECT_TO_VERIFY_EMAIL = "REDIRECT_TO_VERIFY_EMAIL";
export const REDIRECT_TO_CONFIGURE_MFA = "REDIRECT_TO_CONFIGURE_MFA";
export const SHOW_MFA_VERIFICATION = "SHOW_MFA_VERIFICATION";
export const HIDE_MFA_VERIFICATION = "HIDE_MFA_VERIFICATION";
export const VERIFY_MFA_CODE = "VERIFY_MFA_CODE";
export const MFA_VERIFICATION_SUCCESS = "MFA_VERIFICATION_SUCCESS";